import { useTranslation } from '../hooks/useTranslation';
import './CallToAction.css';

function CallToAction() {
  const { t } = useTranslation();

  return (
    <div className="cta-slide">
      <div className="cta-content">
        <div className="cta-column">
          <div className="cta-title">{t('cta1', 'en')}</div>
          <div className="cta-subtitle">{t('cta2', 'en')}</div>
        </div>
        <div className="cta-column">
          <div className="cta-title">{t('cta1', 'fr')}</div>
          <div className="cta-subtitle">{t('cta2', 'fr')}</div>
        </div>
      </div>
    </div>
  );
}

export default CallToAction;
